import React from 'react'
import type { WorkOrder } from '@ztechapps/common.contract'
import { isWorkOrderClosed, WORK_ORDER_CLOSED_STATUS_MESSAGE } from '@ztechapps/work-order.common'
import { StatusBreaddrumb } from '@ztechapps/webui.data-tools'
import { useUpdateWorkOrderStatus } from '../hooks/useUpdateWorkOrderStatus'
import { WorkOrderStatus, WorkOrderStatusBadge } from './index'

/**
 * Standalone status dropdown for a work order. Renders the current status as a
 * clickable badge whose menu drives the same transition logic as the page
 * breadcrumb (cancel/complete confirmations included).
 *
 * @param workOrder - the work order whose status is shown and updated.
 * @param disabled - extra disable flag; the dropdown is also force-disabled
 *   whenever the work order is closed (Cancelled or Destructed).
 */
export type WorkOrderStatusDropdownProps = { workOrder: WorkOrder; disabled?: boolean }

export const WorkOrderStatusDropdown = ({ workOrder, disabled }: WorkOrderStatusDropdownProps) => {
  const { onUpdate, statusMenu, loading } = useUpdateWorkOrderStatus(workOrder)

  return (
    <StatusBreaddrumb
      status={workOrder?.status}
      loading={loading}
      component={{ status: WorkOrderStatus, statusBadge: WorkOrderStatusBadge }}
      statusMenu={statusMenu}
      onUpdate={onUpdate}
      disabled={isWorkOrderClosed(workOrder?.status) || disabled}
      disabledReason={isWorkOrderClosed(workOrder?.status) ? WORK_ORDER_CLOSED_STATUS_MESSAGE : undefined}
    />
  )
}
